<template>
  <div class="contact-page">
    <div class="page-container">
      <!-- 面包屑 -->
      <nav class="breadcrumb">
        <a class="bc-link" @click.prevent="goHome">首页</a>
        <span class="bc-sep">/</span>
        <span class="bc-current">患者档案</span>
      </nav>

      <!-- Hero -->
      <div class="hero-row">
        <div class="hero-left">
          <p class="hero-brand">关盈堂 · 患者档案</p>
          <h1 class="hero-title">一人一档，让关怀更精准</h1>
          <p class="hero-subtitle">从完整的患者记录开始，为每一次健康服务做好准备。</p>
        </div>
        <button class="hero-add" type="button" @click="openAddDialog">
          <span class="hero-add-plus" aria-hidden="true">＋</span>
          <span>新建患者档案</span>
        </button>
      </div>

      <!-- 提示条 -->
      <div class="notice-bar">
        <span class="notice-icon" aria-hidden="true">!</span>
        <p class="notice-text">患者资料仅用于健康服务建档，请在患者知情同意后填写；新增与修改以服务端保存结果为准。</p>
      </div>

      <!-- 患者档案卡 -->
      <div class="panel-card">
        <div class="panel-head">
          <h2 class="panel-title">患者档案</h2>
          <span class="panel-badge">{{ patientTotal }} 位</span>
        </div>

        <!-- 查找患者 -->
        <div class="search-block">
          <label class="search-label">查找患者</label>
          <el-input class="patient-search" v-model="searchText" placeholder="姓名或出生日期"
            @keyup.enter.native="search">
            <i slot="suffix" class="el-input__icon el-icon-search search-icon" @click="search"></i>
          </el-input>
        </div>

        <!-- 患者列表 -->
        <div class="patient-list" v-if="currentContactArray.length > 0">
          <div class="patient-row" v-for="(row, index) in currentContactArray" :key="row.patientId || index">
            <div class="pr-profile">
              <span class="pr-avatar">{{ avatarText(row.name) }}</span>
              <div class="pr-profile-info">
                <span class="pr-name">{{ row.name }}</span>
                <span class="pr-sub">{{ row.sexText }} · 患者档案</span>
              </div>
            </div>

            <div class="pr-cell">
              <span class="pr-label">公历生日</span>
              <span class="pr-value">{{ row.birthday || '未填写' }}</span>
            </div>
            <div class="pr-cell">
              <span class="pr-label">农历生日</span>
              <span class="pr-value">{{ row.lunarBirthday || '未填写' }}</span>
            </div>
            <div class="pr-cell">
              <span class="pr-label">电话号码</span>
              <span class="pr-value">{{ row.phoneNo || '未填写' }}</span>
            </div>
            <div class="pr-cell">
              <span class="pr-label">常住地址</span>
              <span class="pr-value">{{ row.liveArea || '未填写' }}</span>
            </div>
            <div class="pr-cell">
              <span class="pr-label">出生地址</span>
              <span class="pr-value">{{ row.birthArea || '未填写' }}</span>
            </div>

            <div class="pr-action">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <span class="pr-op-btn">操作</span>
                  <i class="el-icon-arrow-down el-icon--right contact-dropdown-arrow"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="contact-op-dropdown">
                  <el-dropdown-item @click.native.prevent="startPrescription(index)">
                    <el-button class="contact-op-item" type="text" size="medium"><i
                        class="el-icon-edit-outline"></i> 去开方 </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native.prevent="editRow(index)">
                    <el-button class="contact-op-item" type="text" size="medium"><i class="el-icon-edit"></i> 编辑
                    </el-button>
                  </el-dropdown-item>
                  <el-dropdown-item @click.native.prevent="deleteRow(index)">
                    <el-button class="contact-op-item contact-op-delete" type="text" size="medium"><i
                        class="el-icon-delete"></i> 删除 </el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div class="patient-empty" v-else>
          <p>{{ emptyText }}</p>
        </div>

        <!-- 底部：统计 + 分页 + 新增 -->
        <div class="panel-foot">
          <span class="foot-total">共找到 {{ patientTotal }} 位患者</span>
          <div class="foot-right">
            <el-pagination v-if="totalPage > 10" class="pagination" background layout="prev, pager, next"
              :current-page="currentPageNo" @current-change="pageChange" :total="totalPage" />
            <button class="foot-add" type="button" @click="openAddDialog">＋ 新增档案</button>
          </div>
        </div>
      </div>

      <!-- 底部提示 -->
      <div class="page-bottom">
        <p class="bottom-hint">请在患者知情同意后填写资料，仅记录健康服务必要信息。</p>
        <button class="bottom-back" type="button" @click="goHome">
          <span>返回我的服务</span>
          <span class="bottom-back-arrow" aria-hidden="true">→</span>
        </button>
      </div>
    </div>

    <!-- 使用封装的患者表单弹窗组件 -->
    <patient-form-dialog
      :visible.sync="contactDialogVisible"
      :mode="dialogMode"
      :patient-data="currentEditContact"
      dialog-width="800px"
      :show-tips="true"
      @success="onFormSuccess"
    ></patient-form-dialog>
  </div>
</template>

<script>
import calendar from "js-calendar-converter";
import PatientFormDialog from "@/components/widgets/PatientFormDialog.vue";
export default {
  components: {
    PatientFormDialog: PatientFormDialog,
  },
  data() {
    return {
      tableBorder: false,
      searchText: "",
      currentContactArray: [],
      patientTotal: 0,
      currentPageNo: 1,
      pageSize: 5,
      totalPage: 1,
      emptyText: "您还没有患者",
      contactDialogVisible: false,
      dialogMode: "add",
      currentEditContact: null,
      pendingEditPatientId: null,
    };
  },
  mounted() {
    if (this.$route.query.editPatientId) {
      this.pendingEditPatientId = this.$route.query.editPatientId;
    }
    this.getContactList();
  },
  methods: {
    shouldShowTime(hour, minute) {
      return !(this.isEmptyValue(hour) && this.isEmptyValue(minute));
    },
    isEmptyValue(value) {
      return value === "" || value === null || value === undefined;
    },
    formatTimeValue(value) {
      if (value === "-1" || value === -1 || value === "--") {
        return "--";
      }
      return value;
    },
    isUserTypeByValue(roles, val) {
      for (var i = 0; i < roles.length; i++) {
        var value = roles[i];
        if (value == val) {
          return true;
        }
      }
      return false;
    },
    getContactList() {
      this.wjtHttp.post(
        this,
        "/api/patient/v1/list",
        {
          name: this.searchText,
          pageNum: this.currentPageNo,
          pageSize: this.pageSize,
        },
        false,
        function (res) {
          var data = res.data;
          if (data.code == 200) {
            var contactList = data.rows;
            this.patientTotal = data.total || 0;
            this.totalPage = Math.ceil(data.total / this.pageSize) * 10;
            if (!this.utils.isEmptyStr(contactList)) {
              for (var i = 0; i < contactList.length; i++) {
                contactList[i].sexText =
                  contactList[i].sex == "1" ? "男" : "女";
                if (!contactList[i].lunarBirthday) {
                  var birthdayArray = contactList[i].birthday.split("-");
                  var lunarDate = calendar.solar2lunar(
                    birthdayArray[0],
                    birthdayArray[1],
                    birthdayArray[2]
                  );
                  contactList[i].lunarBirthday =
                    lunarDate.lYear +
                    "年" +
                    lunarDate.IMonthCn +
                    lunarDate.IDayCn;
                }
              }
            }
            this.currentContactArray = contactList;
            if (this.pendingEditPatientId) {
              var editIndex = -1;
              for (var j = 0; j < contactList.length; j++) {
                if (contactList[j].patientId == this.pendingEditPatientId) {
                  editIndex = j;
                  break;
                }
              }
              if (editIndex >= 0) {
                this.editRow(editIndex);
              }
              this.pendingEditPatientId = null;
            }
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "患者查询异常，请联系管理员",
              type: "error",
            });
          }
        }.bind(this),
        function (err) {
          console.log(err);
        }
      );
    },
    search() {
      this.currentPageNo = 1;
      this.getContactList();
    },
    goHome() {
      this.$router.push("/");
    },
    avatarText(name) {
      var n = name ? String(name) : "";
      return n ? n.charAt(0) : "患";
    },
    openAddDialog() {
      this.dialogMode = "add";
      this.currentEditContact = null;
      this.contactDialogVisible = true;
    },
    startPrescription(index) {
      var userInfo = this.$store.getters.getUserInfo;
      // userInfo.doctor;
      var roles = "";
      var role = "common";
      var roles = userInfo.roles;
      if (
        this.isUserTypeByValue(roles, "doctor") &&
        userInfo.doctor.status === "0"
      ) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "admin")) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "level1")) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "level2")) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "superadmin")) {
        role = "doctor";
      }
      if (this.isUserTypeByValue(roles, "common_doctor")) {
        role = "doctor";
      }
      if (role != "doctor") {
        console.log("roles", role);
        this.$message.error("没有开方权限");
        return;
      } else {
        // sessionStorage.setItem('contactList',JSON.stringify(this.currentContactArray[index]))
        // this.$router.push('/addPrescriptionContact')
        sessionStorage.setItem(
          "contactList",
          JSON.stringify(this.currentContactArray[index])
        );
        this.$router.push({
          path: "/addPrescriptionContact",
          query: {
            serviceIndex:6
          },
        });
      }
    },

    drugRecord(index) {
      var contact = this.currentContactArray[index];
      sessionStorage.setItem("contactInfo", JSON.stringify(contact));
      this.$router.push({
        path: "/medicalRecords",
      });
    },
    editRow(index) {
      this.dialogMode = "edit";
      var contact = JSON.parse(JSON.stringify(this.currentContactArray[index]));
      var birthdayArray;
      if (contact.birthday.indexOf("-") >= 0) {
        birthdayArray = contact.birthday.split("-");
      } else {
        var parts = contact.birthday.split(/\D+/);
        birthdayArray = parts
          .map(function (part) {
            if (part.length < 2) {
              return "0" + part;
            }
            return part;
          })
          .map(Number);
      }
      var lunarObj = calendar.solar2lunar(
        birthdayArray[0],
        birthdayArray[1],
        birthdayArray[2]
      );
      contact.displayBirth =
        "公历" +
        birthdayArray[0] +
        "年" +
        birthdayArray[1] +
        "月" +
        birthdayArray[2] +
        "日" +
        " 农历" +
        lunarObj.lYear +
        "年" +
        lunarObj.IMonthCn +
        lunarObj.IDayCn;
      this.currentEditContact = contact;
      this.contactDialogVisible = true;
    },
    onFormSuccess() {
      this.getContactList();
      this.currentEditContact = null;
    },
    deleteRow(index) {
      this.$confirm("确定删除该患者信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(
          function () {
            var contact = this.currentContactArray[index];
            this.wjtHttp.delete(
              this,
              "/api/patient/v1/" + contact.patientId,
              {},
              false,
              function (res) {
                var data = res.data;
                if (data.code == 200) {
                  this.$message({
                    message: "患者已删除",
                    type: "success",
                  });
                  this.currentEditContact = null;
                  this.getContactList();
                } else {
                  this.$message({
                    message:
                      data.msg && data.msg.length > 0
                        ? data.msg
                        : "删除失败，请联系管理员",
                    type: "error",
                  });
                }
              }.bind(this),
              function (err) {
                console.log(err);
              }
            );
          }.bind(this)
        )
        .catch(function () {});
    },

    pageChange(pageNo) {
      this.currentPageNo = pageNo;
      this.getContactList();
    },
  },
  watch: {
    searchText: function (val) {
      if (this.utils.isEmptyStr(val)) {
        this.currentPageNo = 1;
        this.getContactList();
      }
    },
  },
};
</script>

<style scoped>
/* ============================================================
   ContactPage — 患者档案（青绿主题 / 参考设计图）
   ============================================================ */
.contact-page {
  min-height: 60vh;
  background: #f5f7f2;
  color: #304744;
  padding-bottom: 20px;
}

.page-container {
  max-width: 1220px;
  margin: 0 auto;
  padding: 32px 24px 40px;
}

/* ========== 面包屑 ========== */
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  margin-bottom: 18px;
}

.bc-link {
  color: #527f77;
  cursor: pointer;
}

.bc-link:hover {
  color: #009798;
}

.bc-sep {
  color: #b6c6c1;
}

.bc-current {
  color: #304744;
  font-weight: 600;
}

/* ========== Hero ========== */
.hero-row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 22px;
}

.hero-brand {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 600;
  color: #009798;
  letter-spacing: 1px;
}

.hero-title {
  margin: 0 0 12px;
  font-size: 40px;
  font-weight: 700;
  color: #304744;
  letter-spacing: 1px;
  line-height: 1.2;
}

.hero-subtitle {
  margin: 0;
  font-size: 17px;
  color: #527f77;
}

.hero-add {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 24px;
  border: 1px solid #009798;
  border-radius: 12px;
  background: #009798;
  color: #fff;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 10px 22px rgba(0, 151, 152, 0.22);
}

.hero-add:hover {
  background: #007e7f;
  border-color: #007e7f;
  transform: translateY(-2px);
}

.hero-add-plus {
  font-size: 18px;
  line-height: 1;
}

/* ========== 提示条 ========== */
.notice-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 22px;
  margin-bottom: 26px;
  border: 1px solid #f2e4c4;
  border-radius: 14px;
  background: #fdf7e9;
}

.notice-icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #c9a24a;
  color: #c9a24a;
  font-size: 16px;
  font-weight: 700;
}

.notice-text {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #8a6d3b;
}

/* ========== 档案卡 ========== */
.panel-card {
  background: #fff;
  border: 1px solid #e9efec;
  border-radius: 22px;
  padding: 30px 34px 26px;
  box-shadow: 0 10px 30px rgba(23, 61, 59, 0.06);
}

.panel-eyebrow {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #a9bcb6;
}

.panel-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
}

.panel-title {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  color: #304744;
}

.panel-badge {
  padding: 5px 14px;
  border-radius: 10px;
  background: #e6f4f1;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
}

/* 查找患者 */
.search-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 22px;
}

.search-label {
  font-size: 16px;
  color: #7f9994;
}

.patient-search {
  max-width: 560px;
}

.patient-search>>>.el-input__inner {
  height: 44px;
  border-radius: 12px;
  border-color: #d3e6e3;
  color: #304744;
  font-size: 16px;
}

.patient-search>>>.el-input__inner:focus {
  border-color: #009798;
}

.patient-search>>>.el-input__suffix {
  display: flex;
  align-items: center;
}

.search-icon {
  color: #009798;
  font-size: 17px;
  cursor: pointer;
}

.search-icon:hover {
  color: #007e7f;
}

/* ========== 患者列表 ========== */
.patient-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.patient-row {
  display: grid;
  grid-template-columns: 190px 130px 156px 130px 1fr 1fr 110px;
  align-items: center;
  gap: 16px;
  padding: 18px 22px;
  border: 1px solid #e9efec;
  border-radius: 16px;
  background: #fbfdfc;
  transition: all 0.2s ease;
}

.patient-row:hover {
  border-color: #b7ddd8;
  background: #fff;
  box-shadow: 0 10px 24px rgba(23, 61, 59, 0.07);
}

.pr-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.pr-avatar {
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #d9efeb;
  color: #009798;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pr-profile-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.pr-name {
  font-size: 18px;
  font-weight: 700;
  color: #304744;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pr-sub {
  font-size: 16px;
  color: #9aa8a3;
}

.pr-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.pr-label {
  font-size: 16px;
  color: #a9bcb6;
}

.pr-value {
  font-size: 16px;
  font-weight: 600;
  color: #304744;
  word-break: break-all;
}

.pr-action {
  display: flex;
  justify-content: flex-end;
}

.pr-op-btn {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 18px;
  border: 1px solid #b7ddd8;
  border-radius: 10px;
  background: #fff;
  color: #009798;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pr-op-btn:hover {
  background: #eaf6f4;
  border-color: #009798;
}

.contact-dropdown-arrow {
  color: #009798;
  margin-left: 2px;
}

.contact-op-btn {
  color: #009798;
  font-weight: 600;
}

.contact-op-dropdown>>>.el-dropdown-menu__item {
  padding: 0 20px;
  line-height: 36px;
}

.contact-op-dropdown>>>.el-dropdown-menu__item:hover {
  background-color: #eaf6f4;
}

.contact-op-item {
  color: #009798;
  font-weight: 500;
}

.contact-op-item:hover,
.contact-op-item:focus {
  color: #007e7f;
}

.contact-op-item i {
  margin-right: 4px;
}

.contact-op-delete {
  color: #d35342;
}

.contact-op-delete:hover,
.contact-op-delete:focus {
  color: #b93c2e;
}

/* 空状态 */
.patient-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  border: 1px dashed #dcebe7;
  border-radius: 16px;
  background: #fbfdfc;
}

.patient-empty p {
  margin: 0;
  font-size: 17px;
  color: #9aa8a3;
}

/* ========== 卡内底部 ========== */
.panel-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #eef2f0;
}

.foot-total {
  font-size: 16px;
  color: #7f9994;
}

.foot-right {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.pagination {
  margin: 0;
}

.foot-add {
  height: 40px;
  padding: 0 20px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #009798;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.foot-add:hover {
  background: #eaf6f4;
}

/* ========== 底部提示 ========== */
.page-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.bottom-hint {
  margin: 0;
  font-size: 16px;
  color: #9aa8a3;
}

.bottom-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 22px;
  border: 1px solid #cfdcd8;
  border-radius: 12px;
  background: #fff;
  color: #304744;
  font-family: inherit;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bottom-back:hover {
  border-color: #009798;
  color: #009798;
}

.bottom-back-arrow {
  color: #009798;
  font-weight: 700;
}

/* ========== 分页配色 ========== */
.pagination>>>.el-pager li.active {
  background-color: #009798 !important;
  color: #fff !important;
}

.pagination>>>.el-pager li:hover {
  color: #009798;
}

.pagination>>>.btn-prev,
.pagination>>>.btn-next {
  background-color: #f1f7f5;
}

/* ========== 响应式 ========== */
@media (max-width: 1280px) {
  .patient-row {
    grid-template-columns: 180px 1fr 1fr 110px;
    row-gap: 16px;
  }

  .pr-profile {
    grid-column: span 3;
  }

  .pr-action {
    grid-column: 4;
    grid-row: 1;
    align-self: center;
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 20px 16px 32px;
  }

  .hero-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-add {
    width: 100%;
    justify-content: center;
  }

  .panel-card {
    padding: 20px 16px;
    border-radius: 18px;
  }

  .panel-title {
    font-size: 22px;
  }

  .patient-search {
    max-width: 100%;
  }

  .patient-row {
    grid-template-columns: 1fr;
    row-gap: 14px;
  }

  .pr-profile,
  .pr-action {
    grid-column: 1;
    grid-row: auto;
  }

  .pr-action {
    justify-content: flex-start;
  }

  .panel-foot,
  .page-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
